import { reactive } from "@vue/composition-api";
import _axios from "@/axios";

export function usePartner() {
  let partnerData = reactive({
    partners: [],
    partner: null,
    isLoading: false,
  });

  function listPartners() {
    partnerData.isLoading = true;
    return _axios
      .get("/list-partner")
      .then((response) => {
        partnerData.partners = response.data.data;
        partnerData.isLoading = false;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function showPartner(id) {
    return _axios
      .get("/partner/" + id)
      .then((response) => {
        partnerData.partner = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  return {
    partnerData,
    listPartners,
    showPartner,
  };
}
